import { COUNTRY_CODE_AU, COUNTRY_CODE_NZ } from '../countryCodes.js';

export const PRODUCT_CODE_NZ_GEM = 'CCNZGEM';
export const PRODUCT_CODE_DAVID_JONES_PRESTIGE = 'CCAUDJG';
export const PRODUCT_CODE_DAVID_JONES_PREMIERE = 'CCAUDJM';
export const PRODUCT_CODE_TWENTY_EIGHT_DEGREES = 'CCAU28D';
export const PRODUCT_CODE_GO = 'CCAUGOM';
export const PRODUCT_CODE_AU_GEM = 'CCAUGEM';
export const PRODUCT_CODE_AFS = 'CCAUAFS'; // AU Apple Financial Service aka CreditLine credit card
export const PRODUCT_CODE_LOW_RATE = 'CCAULRM';

export const STEP_DAVID_JONES_PREMIERE = '/davidjonespremiere';
export const STEP_DAVID_JONES_PRESTIGE = '/davidjonesprestige';
export const STEP_TWENTY_EIGHT_DEGREES = '/28degrees';
export const STEP_GO = '/go';
export const STEP_GEM_AU = '/gem';
export const STEP_CREDIT_LINE = '/creditline';
export const STEP_LOW_RATE = '/low-rate';
export const STEP_PRODUCT_COMPARISON = '/davidjones-product-comparison';
export const STEP_ABOUT_YOU = '/about-you';
export const STEP_ACCEPTANCE = '/acceptance';
export const STEP_ADDRESS_DETAILS = '/address-details';
export const STEP_BIOMETRICS_ABOUT_YOU = '/biometrics-about-you';
export const STEP_BIOMETRICS_ADDRESS_DETAILS = '/biometrics-address-details';
export const STEP_BIOMETRICS_CANCELLED = '/biometrics-cancelled';
export const STEP_BIOMETRICS_COMPLETE = '/biometrics-complete';
export const STEP_BIOMETRICS_IDENTIFICATION = '/biometrics-identification';
export const STEP_BIOMETRICS_RETURN = '/biometrics-return';
export const STEP_COMMITMENTS = '/commitments';
export const STEP_ADDITIONAL_CARD_HOLDER = '/additional-card-holder';
export const STEP_CONFIRM_CREDIT_LIMIT = '/credit-limit-details';
export const STEP_LOAN_INFORMATION = '/loan-information';
export const STEP_CONFIRM_INCOME = '/confirm-income';
export const STEP_CONTACT_DETAILS = '/contact-details';
export const STEP_CREDIT_LIMIT = '/credit-limit';
export const STEP_DVS_CONSENT = '/dvs-consent';
export const STEP_EIDV = '/check-your-identity';
export const STEP_AUS_POST = '/aus-post-identity';
export const STEP_FACIAL_BIOMETRICS_CONSENT = '/facial-biometrics-consent';
export const STEP_VERIFY_INSTORE = '/verify-identity-instore';
export const STEP_EXPENSES = '/expenses';
export const STEP_FINANCIALS = '/financials';
export const STEP_IDENTIFICATION = '/identification';
export const STEP_INCOME = '/income';
export const STEP_LANDING = '/';
export const STEP_NZ_GEM_V2 = '/gem-nz';
export const STEP_LATITUDE_ID_INTRODUCTION = '/latitude-id-introduction';
export const STEP_EMAIL_VERIFICATION = '/verify-email';
export const STEP_LATITUDE_ID = '/latitude-id';
export const STEP_OUTCOME = '/outcome';
export const STEP_OUTCOME_FIN_TABLE = '/outcome-fin-table';
export const STEP_OUTCOME_TIMEOUT = '/outcome-timeout';
export const STEP_PASSWORD = '/password';
export const STEP_PROCESSING = '/processing';
export const STEP_PROCESSING_ACCEPTANCE = '/processing-acceptance';
export const STEP_PROCESSING_BIOMETRICS = '/processing-biometrics';
export const STEP_PROCESSING_IDV = '/processing-IDV';
export const STEP_PROCESSING_PENDING_POI = '/processing-pending-poi';
export const STEP_PROCESSING_POI = '/processing-poi';
export const STEP_PROCESSING_LOAN_INFORMATION = '/processing-loan-information';
export const STEP_RESUME_ACCEPTANCE = '/resume-acceptance';
export const STEP_RESUME_APPLICATION_EXPIRED = '/resume-application-expired';
export const STEP_RESUME_SAVED = '/saved';
export const STEP_RESUME_YOUR_APPLICATION = '/resume-your-application';
export const STEP_SAVED = '/saved';
export const STEP_VERIFY = '/verify';
export const STEP_VERIFY_APPLICATION_MOBILE = '/verify-mobile';
export const STEP_VERIFY_DOCUMENT_UPLOAD = '/verify-document-upload';
export const STEP_VERIFY_FICONNECT = '/verify-ficonnect';
export const STEP_VERIFY_IDENTITY = '/verify-identity';
export const STEP_VERIFY_INCOME = '/verify-income';
export const STEP_PROOF_OF_ADDRESS = '/proof-of-address';
export const STEP_VERIFY_TO_RESUME = '/verify-to-resume';
export const STEP_AGREE_AND_CONTINUE = '/agree-and-continue';
export const STEP_ID_DOC_UPLOAD = '/id-doc-upload';
export const STEP_BALANCE_TRANSFER = '/balance-transfer';
export const STEP_CREDIT_LIMIT_REQUEST = '/credit-limit-request';
export const STEP_CREDIT_LIMIT_ALLOCATION = '/credit-limit-allocation';

export const APPLE_MERCHANT_ID = '700021';

export const PRODUCT_DAVID_JONES = 'DavidJones';

export const DAVID_JONES_FEATURE_PREFIX = 'dj';

export const CREDIT_CARD_TYPE_MASTER = 'master';
export const CREDIT_CARD_TYPE_VISA = 'visa';
export const CREDIT_CARD_TYPE_PLAIN = 'plain';

export const CHANNEL_INSTORE = 'INSTORE';
export const CHANNEL_EXTERNAL_QR = 'EXTERNAL_QR';
export const CHANNEL_DIRECT = 'DIRECT';
export const CHANNEL_ONLINE = 'ONLINE';
export const CHANNEL_APPLY_AND_SHOP = 'APPLY_AND_SHOP';

export const DATALAYER_CHANNEL_INSTORE = 'Instore';
export const DATALAYER_CHANNEL_EXTERNAL_QR = 'External QR';
export const DATALAYER_CHANNEL_APPLY_AND_BUY = 'Apply and Buy';
export const DATALAYER_CHANNEL_DIRECT = 'Direct';

export const productGemV2 = {
  name: 'Gem Visa',
  landingPath: STEP_LANDING,
  docUploadCardType: 'gemvisanz',
  featureToggleKeyPrefix: 'nzGem',
  creditCardType: CREDIT_CARD_TYPE_VISA,
  maxCreditLimit: 40000,
  minCreditLimit: 1000,
  defaultApplyAndBuy: {
    merchantId: '4567489',
    shortCode: '999',
    solCode: 'FD1',
    channel: CHANNEL_DIRECT,
  },
  urls: {
    importantInformation:
      'https://www.gemfinance.co.nz/gem-visa-info/?gemid2=cc-funnel%3Agemnz%3Aintro%3Awhat-to-expect%3AImportant%2520Information%3Abefore-you-start-your-application',
    importantPrivacyNotice:
      'https://assets.latitudefinancial.com/gem-essentials/nz-gem-visa-privacy-notice.pdf?gemid2=cc-funnel%3Agemnz%3Aintro%3Awhat-to-expect%3AImportant%2520Privacy%2520Notice%3Abefore-you-start-your-application&_gl=1*rvh771*_ga*Nzc4MzQ5NDkyLjE3NTYxODAyNTI.*_ga_ZXRZ5ZKK5R*czE3NTk4NzkwMTAkbzY5JGcxJHQxNzU5ODgzMjIwJGo2MCRsMCRoMA',
    conditionsOfUse:
      'https://assets.gemfinance.co.nz/legals/conditions-of-use/gemvisa-nz/cou.pdf?_ga=2.236588865.1323252382.1615416779-941858851.1587360214&gemid2=cc-funnel%3Agemnz%3Aintro%3Awhat-to-expect%3AConditions%2520of%2520Use%3Abefore-you-start-your-application',
    initialDisclosureStatement:
      'https://assets.latitudefinancial.com/gem-essentials/nz-gem-visa-ids.pdf?gemid2=cc-funnel%3Agemnz%3Aintro%3Awhat-to-expect%3AInitial%2520Disclosure%2520Statement%3Abefore-you-start-your-application&_gl=1*rvh771*_ga*Nzc4MzQ5NDkyLjE3NTYxODAyNTI.*_ga_ZXRZ5ZKK5R*czE3NTk4NzkwMTAkbzY5JGcxJHQxNzU5ODgzMjIwJGo2MCRsMCRoMA',
    interestFreeGuideUrl:
      'https://gemfinance.zendesk.com/hc/en-nz/articles/41249488175761-6-Months-Interest-Free-Shopping-with-Gem-Visa',
  },
  datalayer: {
    siteSection: 'gemnz',
  },
};

export const PRODUCTS = {
  [COUNTRY_CODE_AU]: {
    [PRODUCT_CODE_DAVID_JONES_PREMIERE]: {
      name: 'David Jones Premiere',
      landingPath: STEP_DAVID_JONES_PREMIERE,
      docUploadCardType: 'dj',
      featureToggleKeyPrefix: DAVID_JONES_FEATURE_PREFIX,
      ratesAndFeesFeatureToggleKey: 'premiereRatesAndFees',
      creditCardType: CREDIT_CARD_TYPE_MASTER,
      maxCreditLimit: 50000,
      minCreditLimit: 1000,
      defaultApplyAndBuy: {
        merchantId: '000421316',
        shortCode: '299',
        solCode: 'HD2',
      },
      datalayer: {
        siteSection: 'dj',
      },
      urls: {
        conditionsOfUse: 'https://assets.latitudefinancial.com/legals/conditions-of-use/davidjones-au/cou.pdf',
      },
    },
    [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: {
      name: 'David Jones Prestige',
      landingPath: STEP_DAVID_JONES_PRESTIGE,
      docUploadCardType: 'dj',
      featureToggleKeyPrefix: DAVID_JONES_FEATURE_PREFIX,
      ratesAndFeesFeatureToggleKey: 'prestigeRatesAndFees',
      creditCardType: CREDIT_CARD_TYPE_MASTER,
      maxCreditLimit: 50000,
      minCreditLimit: 6000,
      defaultApplyAndBuy: {
        merchantId: '000421316',
        shortCode: '299',
        solCode: 'HD3',
        channel: CHANNEL_DIRECT,
      },
      datalayer: {
        siteSection: 'dj',
      },
      urls: {
        conditionsOfUse: 'https://assets.latitudefinancial.com/legals/conditions-of-use/davidjones-au/cou.pdf',
      },
    },
    [PRODUCT_CODE_TWENTY_EIGHT_DEGREES]: {
      name: 'Latitude 28° Global Platinum Mastercard',
      landingPath: STEP_TWENTY_EIGHT_DEGREES,
      docUploadCardType: '28degreescard',
      featureToggleKeyPrefix: 'au28D',
      creditCardType: CREDIT_CARD_TYPE_MASTER,
      maxCreditLimit: 50000,
      minCreditLimit: 1000,
      defaultApplyAndBuy: {
        shortCode: '666',
        solCode: 'BE5',
        merchantId: '000000000',
        channel: CHANNEL_DIRECT,
      },
      datalayer: {
        siteSection: '28degrees',
      },
      urls: {
        conditionsOfUse: 'https://assets.latitudefinancial.com/legals/credit-card-general-terms-and-conditions.pdf',
      },
      terms: {
        conditionsOfUse: 'Latitude Credit Card General Terms and Conditions',
        financialTable: 'Contract Schedule',
        generalPurchases: 'general purchases',
        monthlyCreditCardFee: 'monthly credit card fee',
        creditCardGeneralPurchases: 'credit card general purchases',
      },
    },
    [PRODUCT_CODE_GO]: {
      name: 'Latitude GO Mastercard',
      landingPath: STEP_GO,
      docUploadCardType: 'go',
      featureToggleKeyPrefix: 'go',
      creditCardType: CREDIT_CARD_TYPE_MASTER,
      maxCreditLimit: 50000,
      minCreditLimit: 1000,
      defaultApplyAndBuy: {
        shortCode: '999',
        solCode: 'ND7',
        merchantId: '4567489',
        channel: CHANNEL_DIRECT,
        storeFinderUrl: 'https://stores.harveynorman.com.au/',
      },
      datalayer: {
        siteSection: 'go',
      },
      urls: {
        conditionsOfUse: 'https://assets.latitudefinancial.com/legals/credit-card-general-terms-and-conditions.pdf',
      },
      terms: {
        conditionsOfUse: 'Latitude Credit Card General Terms and Conditions',
        financialTable: 'Contract Schedule',
        generalPurchases: 'general purchases',
        monthlyCreditCardFee: 'monthly credit card fee',
        creditCardGeneralPurchases: 'credit card general purchases',
      },
    },
    [PRODUCT_CODE_AU_GEM]: {
      name: 'Latitude Gem Visa',
      landingPath: STEP_GEM_AU,
      docUploadCardType: 'gemvisaau',
      featureToggleKeyPrefix: 'auGem',
      creditCardType: CREDIT_CARD_TYPE_VISA,
      maxCreditLimit: 50000,
      minCreditLimit: 1000,
      defaultApplyAndBuy: {
        shortCode: '999',
        solCode: 'ED1',
        merchantId: '4567489',
        channel: CHANNEL_DIRECT,
        storeFinderUrl: 'https://www.latitudefinancial.com.au/interest-free/find-a-store/',
      },
      datalayer: {
        siteSection: 'gem',
      },
      urls: {
        conditionsOfUse: 'https://assets.latitudefinancial.com/legals/credit-card-general-terms-and-conditions.pdf',
      },
      terms: {
        conditionsOfUse: 'Latitude Credit Card General Terms and Conditions',
        financialTable: 'Contract Schedule',
        generalPurchases: 'general purchases',
        monthlyCreditCardFee: 'monthly credit card fee',
        creditCardGeneralPurchases: 'credit card general purchases',
      },
    },
    [PRODUCT_CODE_AFS]: {
      name: 'CreditLine',
      landingPath: STEP_CREDIT_LINE,
      docUploadCardType: 'creditline',
      featureToggleKeyPrefix: 'afs',
      creditCardType: CREDIT_CARD_TYPE_PLAIN,
      maxCreditLimit: 12000,
      minCreditLimit: 1000,
      defaultApplyAndBuy: {
        shortCode: '489',
        solCode: 'KB1',
        merchantId: APPLE_MERCHANT_ID,
        channel: CHANNEL_ONLINE,
        storeFinderUrl: 'https://www.apple.com/au/retail/',
      },
      datalayer: {
        siteSection: 'afs-creditline',
      },
      urls: {
        conditionsOfUse: 'https://assets.latitudefinancial.com/legals/conditions-of-use/creditline-afs/cou.pdf',
      },
    },
    [PRODUCT_CODE_LOW_RATE]: {
      name: 'Latitude Low Rate Mastercard',
      teamName: 'Latitude Low Rate',
      landingPath: STEP_LOW_RATE,
      docUploadCardType: 'lowrate',
      featureToggleKeyPrefix: 'lowRate',
      creditCardType: CREDIT_CARD_TYPE_MASTER,
      maxCreditLimit: 20000,
      minCreditLimit: 1000,
      defaultApplyAndBuy: {
        shortCode: '999',
        solCode: 'LE6',
        merchantId: '000000001',
        channel: CHANNEL_DIRECT,
      },
      datalayer: {
        siteSection: 'low-rate',
      },
      urls: {
        conditionsOfUse: 'https://assets.latitudefinancial.com/legals/credit-card-general-terms-and-conditions.pdf',
        rewardsProgram: 'https://assets.latitudefinancial.com/legals/terms-conditions/lowrate-rewards.pdf',
      },
      terms: {
        conditionsOfUse: 'Latitude Credit Card General Terms and Conditions',
        financialTable: 'Contract Schedule',
        rewardsProgram: 'Latitude Low Rate Mastercard Rewards Program Terms and Conditions',
        generalPurchases: 'general purchases',
        monthlyCreditCardFee: 'monthly credit card fee',
        creditCardGeneralPurchases: 'credit card general purchases',
      },
    },
  },
  [COUNTRY_CODE_NZ]: {
    [PRODUCT_CODE_NZ_GEM]: productGemV2,
  },
};

export const LANDING_PAGE_STEPS = Object.keys(PRODUCTS)
  .map(countryCode => PRODUCTS[countryCode])
  .reduce(
    (acc, countryProducts) => {
      return [...acc, ...Object.keys(countryProducts).map(productCode => countryProducts[productCode].landingPath)];
    },
    ['/gem-nz'],
  );

export const defaultTerms = {
  conditionsOfUse: 'Conditions of Use',
  financialTable: 'Financial Table',
  generalPurchases: 'everyday purchases',
  monthlyCreditCardFee: 'monthly account service fee',
  creditCardGeneralPurchases: 'everyday credit card purchases',
};
